module.exports = __webpack_public_path__ + "static/media/more-all-products-9.f0df1d63.png";